import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Path } from '../helpers/enum';

@Injectable({
  providedIn: 'root',
})
export class RoutingService {
  constructor(
    private router: Router,
    private location: Location,
  ) { }

  goBack() {
    this.location.back();
  }

  goToChatListing() {
    this.route(Path.chatListing, true,);
  }

  goToDetailCustomer(data: any) {
    this.route(Path.detailCustomer, true, data);
  }

  goToDetailLocation(data: any) {
    this.route(Path.detailLocation, true, data);
  }

  goToDetailComboBooking(data: any) {
    this.route(Path.detailComboBooking, true, data);
  }

  goToDetailRefundManagement(data: any) {
    this.route(Path.detailRefundManagment, true, data);
  }

  goToAddCoupons() {
    this.route(Path.addCoupons, true,);
  }

  goToDetailCoupons(data: any) {
    this.route(Path.detailCoupons, true, data);
  }

  goToEditCoupons(data: any) {
    this.route(Path.addCoupons, true, data);
  }

  goToDetailChatManagement(data: any) {
    this.route(Path.detailChatManagment, true, data);
  }

  goToEditService(data: any) {
    this.route(Path.editService, true, data);
  }

  goToAllEarning(data:any){
    this.route(Path.allEarning, true, data);
  }

  goToDetailService(data: any) {
    this.route(Path.detailService, true, data);
  }

  goToDetailComplaints(data: any) {
    this.route(Path.detailComplaint, true, data);
  }

  goToComboPackage(data: any) {
    this.route(Path.detailComboPackage, true, data);
  }

  goToEditComboPackage(data: any) {
    this.route(Path.editComboPackage, true, data);
  }

  goToServiceList() {
    this.route(Path.serviceList, true,);
  }

  goToLocationList() {
    this.route(Path.locationList, true,);
  }

  goToComplaintList() {
    this.route(Path.complainsList, true,);
  }

  goToBookingList() {
    this.route(Path.bookingList, true,);
  }

  goToRefundList() {
    this.route(Path.refundList, true,);
  }

  goToLeadList() {
    this.route(Path.leadList, true,);
  }

  goToPartnerAvailability() {
    this.route(Path.partnerAvailability, true,);
  }

  goToComboBookingList() {
    this.route(Path.comboBooking, true,);
  }

  goToComboPackageList() {
    this.route(Path.comboPackage, true,);
  }


  goToEditPlan(data: any) {
    this.route(Path.addPlan, true, data);
  }

  goToAddPlan() {
    this.route(Path.addPlan, true,);
  }

  dynamicPath(path: string, params: string = '') {
    if (params) {
      this.route(path, false, { id: params });
    } else {
      this.route(path);
    }
  }

  route(path: string, replaceUrl: boolean = false, data?: any) {
    if (!data) {
      this.router.navigate([path], { replaceUrl });
    } else {
      this.router.navigate([path], {
        replaceUrl,
        queryParams: data,
      });
    }
  }

}
